import axios from "axios";
import Cookies from "js-cookie";

// Setting up variables
/*const url =
  "https://salty-ridge-10349.herokuapp.com/https://arhivar.herokuapp.com/api/v1";*/
const url = "";
// const url = "http://localhost:5000";

const getToken = () => {
  let info = Cookies.get("jwt");
  if (info) {
    return info;
  }
};

const API = axios.create({
  baseURL: url,
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});

/*export const fetchPosts = () => API.get("/posts");

export const createPost = (newPost) => API.post("/posts", newPost);

export const updatePost = (id, updatedPost) => {
  API.patch(`/posts/${id}`, updatedPost);
};
export const deletePost = (id) => {
  API.delete(`/posts/${id}`);
};*/

export const likePost = (id) => API.patch(`/posts/${id}/likePost`);

// sign in / sign up routes
export const signIn = (formData) => API.post("/users/login", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgotPassword = (formData) =>
  API.post("/users/forgotPassword", formData);
export const resetPassword = (formData, id) =>
  API.patch(`/users/resetPassword/${id}`, formData);

// multi step form routes
export const updateMe = (formData) => API.patch("/users/updateMe", formData);

// processors routes
export const getProcessors = () => API.get("/processor");
export const getActiveProcessors = () => API.get("/processor/activeProcessors");
export const addProcessor = (formData) => API.post(`/processor`, formData);
export const updateProcessor = (id, formData) =>
  API.patch(`/processor/${id}`, formData);
export const deleteProcessor = (id) => {
  API.delete(`/processor/${id}`);
};

// categories routes
export const getCategories = () => API.get("/category");
export const getActiveCategories = () => API.get("/category/activeCategory");
export const addCategory = (formData) => API.post(`/category`, formData);
export const updateCategory = (id, formData) =>
  API.patch(`/category/${id}`, formData);
export const deleteCategory = (id) => {
  API.delete(`/category/${id}`);
};

// papers routes
export const getCertainCategoryPaperNumber = (id) =>
  API.get(`/paper/paper-number/${id}`);
export const getRecipientAndSenders = () => API.get("/paper/recSendData");
export const addPaper = (formData) => API.post("/paper", formData);
export const getAllPagePapers = (page, limit, query) =>
  API.get(`/paper?page=${page}&limit=${limit}${query}`);
export const getCertainPagePapers = (page, limit, query) =>
  API.get(`/paper/currentYearPapers?page=${page}&limit=${limit}${query}`);
export const allPapersNumber = () => API.get("/paper/countAllPapers");
export const currentYearPapersNumber = (query) =>
  API.get(`/paper/countCurrentYearPapers?${query}`);
export const getNotArchivedPagePapers = (page, limit) =>
  API.get(`/paper/getNotArhivedPapers?page=${page}&limit=${limit}`);
/*export const getNotArchivedPagePapers = () =>
  API.get("/paper/getNotArhivedPapers");*/
export const notArchivedPapersNumber = (query) =>
  API.get(`/paper/countAllPapers?${query}`);
export const preparingForArchive = (formData) =>
  API.post("paper/prepareForArhive", formData);
export const getCertainPaper = (id) => API.get(`/paper/${id}`);
export const updateCertainPaper = (formData, id) =>
  API.patch(`/paper/${id}`, formData);

// current user routes
export const getCurrentUserData = () => API.get("/users/me");
export const updateCurrentUserData = (formData) =>
  API.patch(`/users/updateMe`, formData);
export const updateCurrentUserPassword = (formData) =>
  API.patch("/users/updateMyPassword", formData);

// archive routes
export const createArchive = (formData) => API.post("/arhive", formData);
export const getArchiveOfCurrentUser = (page, limit, query) =>
  API.get(`/arhive?page=${page}&limit=${limit}${query}`);
export const getArchiveOfCurrentUserForCurrentYear = (page, limit, query) =>
  API.get(`/arhive/currentYearArhive?page=${page}&limit=${limit}${query}`);
export const allArchiveNumber = (query) =>
  API.get(`/arhive/countAllArhives?${query}`);
export const currentYearArchiveNumber = (query) =>
  API.get(`/arhive/countCurrentYearArhives?${query}`);
export const getArchivesForDestroying = () =>
  API.get("/arhive/notDestroyedArhive");
export const getArchiveForWord = () => API.get("/arhive/arhiveBook");
export const updateArchive = (id, formData) =>
  API.patch(`/arhive/${id}`, formData);
export const getCertainArchive = (id) => API.get(`/arhive/${id}`);
export const updateCertainArchive = (formData, id) =>
  API.patch(`/arhive/${id}`, formData);

// all users routes
export const getAllUsers = (page, limit, query) =>
  API.get(`/users?page=${page}&limit=${limit}${query}`);
export const getCertainUser = (id) => API.get(`/users/${id}`);
export const updateCertainUser = (formData, id) =>
  API.patch(`/users/${id}`, formData);
export const deleteCertainUser = (id) => API.delete(`/users/${id}`);
export const getCountAllUsers = (query: any) =>
  API.get(`/users/countAllUsers?${query}`);
